import React from 'react';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import { CardText, CardValue, KpiCard } from './KpiList.styles';
import {
	KPI_COLORS,
	summarizeCounts,
} from 'CategoryManagement/CategoryWidget/utils';

const KpiElement = ({
	cardTitle,
	value,
	isLoading,
	setShowFilters,
	setFilters,
}) => {
	if (typeof value === 'object') {
		const { countData, count } = summarizeCounts(value);
		return (
			<KpiCard
				bgcolor={KPI_COLORS[cardTitle]}
				onClick={() => {
					setShowFilters(state => !state);
					setFilters(countData);
				}}
			>
				{isLoading ? (
					<ApLoaderDefault />
				) : (
					<>
						<CardValue>{count}</CardValue>
						<CardText>Filter Applied Count</CardText>
					</>
				)}
			</KpiCard>
		);
	}
	return (
		<KpiCard bgcolor={KPI_COLORS[cardTitle]}>
			{isLoading ? (
				<ApLoaderDefault />
			) : (
				<>
					<CardValue>{value}</CardValue>
					<CardText>{cardTitle}</CardText>
				</>
			)}
		</KpiCard>
	);
};

const KpiList = props => {
	return (
		<>
			{props.data.length > 0 && (
				<>
					{props.data.map(d => (
						<KpiElement
							cardTitle={d.title}
							value={d.value}
							isLoading={false}
							setShowFilters={props.setShowFilters}
							setFilters={props.setFilters}
						/>
					))}
				</>
			)}
		</>
	);
};

export default KpiList;
